import { render, staticRenderFns } from "./search-criteria.vue?vue&type=template&id=227566e3&scoped=true"
import script from "./search-criteria.vue?vue&type=script&lang=js"
export * from "./search-criteria.vue?vue&type=script&lang=js"
import style0 from "./search-criteria.vue?vue&type=style&index=0&id=227566e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227566e3",
  null
  
)

export default component.exports